import { safeFetch } from "../utils/safeFetch";
import { buildApiError } from "../utils/apiErrors";

const voucherRequest = async (path, token, tenant, options = {}) => {
  const response = await safeFetch(`/api/vouchers${path}`, {
    ...options,
    headers: {
      accept: "application/json",
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
      ...(options.body ? { "Content-Type": "application/json" } : {}),
      ...(options.headers || {}),
    },
    cache: "no-store",
  });

  if (!response.ok) {
    throw await buildApiError(response, `HTTP error! status: ${response.status}`);
  }

  return response;
};

export const getVoucher = async (voucherId, token, tenant) => {
  const response = await voucherRequest(`/${encodeURIComponent(voucherId)}`, token, tenant, {
    method: "GET",
  });
  const payload = await response.json();
  return payload?.voucher || null;
};

export const signVoucher = async (voucherId, signature, token, tenant) => {
  const response = await voucherRequest(`/${encodeURIComponent(voucherId)}/sign`, token, tenant, {
    method: "POST",
    body: JSON.stringify(signature),
  });
  const payload = await response.json();
  return payload?.voucher || null;
};

export const printVoucher = async (voucherId, token, tenant) => {
  const response = await voucherRequest(`/${encodeURIComponent(voucherId)}/print`, token, tenant, {
    method: "POST",
  });
  return response.json();
};
